import React from "react";


export const ErrorLoadingCheckForm = () => {
    return <h4>A check in form has not been assigned. Please check with your trainer for more information</h4>;
};
